import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { useLifeDomainsStore } from '../stores/useLifeDomainsStore.js';
export const lifeDomainSchema = z.object({
    id: z.string(),
    name: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const lifeDomainsListResponseSchema = z.object({
    lifeDomains: z.array(lifeDomainSchema),
});
export const useGetLifeDomains = (request, autoFetch = true) => {
    const { setLifeDomains } = useLifeDomainsStore();
    return useQuery({
        queryKey: ['life-domains'],
        queryFn: async () => {
            const response = await request({ url: '/life-domains', method: 'GET' }, lifeDomainsListResponseSchema);
            if (response?.data?.lifeDomains) {
                setLifeDomains(response.data.lifeDomains);
            }
            return response;
        },
        enabled: autoFetch,
    });
};
